<template>
  <div class="cancel-confirmation-summary mt-3">
    <div
      v-for="(summary, index) in summaries"
      :key="index"
      class="border rounded-2 p-3 mb-2"
    >
      <div class="fw-semibold mb-1">{{ summary.beneficiaryName }}</div>
      <div class="row g-2">
        <div class="col-12">
          <div class="text-muted small">
            {{ $t("company_orders.cancel.purpose") }}
          </div>
          <div>{{ summary.purpose }}</div>
        </div>
        <div v-if="summary.periodStart" class="col-md-6">
          <div class="text-muted small">
            {{ $t("company_orders.cancel.period") }}
          </div>
          <div>{{ formatPeriod(summary) }}</div>
        </div>
        <div v-if="summary.mwh !== null" class="col-md-6">
          <div class="text-muted small">
            {{ $t("company_orders.total_selected_mwh") }}
          </div>
          <div>{{ summary.mwh }} MWh</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { formatDate } from "@/composables/formatUtils";
import type { CancellationSummary } from "./confirmCancellationSummary";

defineProps<{
  summaries: CancellationSummary[];
}>();

const formatPeriod = (summary: CancellationSummary): string => {
  if (!summary.periodStart) return "-";
  const start = formatDate(summary.periodStart);
  return summary.periodEnd
    ? `${start} – ${formatDate(summary.periodEnd)}`
    : start;
};
</script>
